export default __webpack_public_path__ + "static/media/latestadd_icon.e09ee9fc.svg";